module.exports = __webpack_public_path__ + "static/media/YF15_3.cf01e390.jpg";